import 'owl.carousel2';

var homeHeroSlideDuration = 6; //seconds
var owlRespFlag_ = true,
	menuflag_ = true;
var didScroll;
var navbarHeight = $('#static-header').outerHeight();
var lastScrollTop = 0;
var delta = 100;

var up3 = true;
var up, up1, up2 = false;
var value = 1;
var value1 = 78;
var value2 = 52;
var value3 = 6;
var value4 = 1;
var increment = 1;
var ceiling = 60;
var ceiling1 = 78;
var ceiling2 = 52;
var ceiling3 = 9;
$(document).ready(function () {
        if ($('#value_prop').length) {
               var value_prop = $('#get-started-footer').attr('data-prop');
               $('#value_prop .wrap').html(value_prop);
        }
	const io = new IntersectionObserver((entries, observer) => {
			const entry = entries[0];
			const element = entry.target;
			if ((entry.isIntersecting)) {
				const src = element.getAttribute('style-lazy');
				element.setAttribute('style', src);
				observer.disconnect();
			}
	});

	const insideSamsara = document.getElementById('inside-samsara-image');
	if (insideSamsara) {
		io.observe(insideSamsara);
	}
	//Modal window functionality
	$(document).on('click', '.video-player-wrap', function(){
		var modalId = $(this).attr('data-id');
		let video = document.getElementById('video');
		const src = video.getAttribute('data-click');
		video.setAttribute('src', src);

		$('#'+modalId+'.modal').addClass('active');
		$('body').toggleClass('modal-open');

		var videoURL = $('#'+modalId).find('iframe').prop('src');
		videoURL += "&autoplay=1";
		$('#'+modalId).find('iframe').prop('src',videoURL);
	});
	$('.modal-container').click(function (e) {
		var modalId = $(this).parent().attr('id');
		var videoURL = $('#'+modalId).find('iframe').prop('src');
		if (videoURL) {
			videoURL = videoURL.replace("&autoplay=1", "");
			$('#'+modalId).find('iframe').prop('src','');
			$('#'+modalId).find('iframe').prop('src',videoURL);
		}

	});

	var syncSliderInd = $(".index-img-quote-carousel");
$(".index-img-quote-carousel").owlCarousel({
	dots: false,
	nav: false,
	loop: true,
	mouseDrag: false,
	touchDrag: false,
	items: 1,
	lazyLoad: true,
	margin: 0,
		autoplay: true,
		autoplayTimeout: 4500,
		animateOut: 'fadeOut',
		animateIn: 'fadeIn'
});
$(".index-content-quote-carousel").owlCarousel({
	dots: true,
	nav: false,
	loop: true,
	mouseDrag: false,
	touchDrag: false,
	items: 1,
	lazyLoad: true,
	margin: 0,
		autoplay: true,
		autoplayTimeout: 4500,
		animateOut: 'fadeOut',
		animateIn: 'fadeIn'
});

$(".index-content-quote-carousel .owl-dot").on('click', function(){
		syncSliderInd.trigger('to.owl.carousel', [$(this).index(), 300]);
		$('.index-content-quote-carousel .owl-dot').removeClass('active');
		$(this).addClass('active');
	})
$(".index-content-quote-carousel .owl-prev").click(function (e) {
	e.preventDefault();
	syncSliderProd.trigger("prev.owl.carousel");
});

	setInterval(PerformCalc1, 300);
	setInterval(PerformCalc, 70);
	setInterval(PerformCalc3, 600);

	// Get started footer
	const includedPages = [
		/^\/[a-zA-Z]{0,2}\/{0,1}$/,
		/\/(fleet).*/,
		/\/(customers).*/,
		/\/(blog).*/,
		/\/(industrial)(?!(\/pricing)).*/,
		/\/(process-monitoring).*/,
		/\/(condition-monitoring).*/,
		/\/(machine-vision).*/,
		/\/(industrial-models).*/,
		/\/(products\/models).*/,
		/\/(remote-monitoring).*/,
		/\/(industrial\/water).*/,
		/\/(industrial\/oil-gas).*/,
		/\/(guides).*/,
		/\/(branded).*/,
		/\/(careers).*/
	];

	var hideFooter = true;
	for (var i = 0; i < includedPages.length; i++) {
		if (includedPages[i].test(window.location.pathname)) {
			hideFooter = false;
			break;
		}
	}
	if (window.outerWidth && window.outerWidth < 767) {
		$("#get-started-header").removeClass("main-header");
		if ($('#get-started-footer').length && !hideFooter) {
			$(window).on('scroll load', function() {
				var fromTop = $(window).scrollTop();
				if (fromTop < window.innerHeight) {
					$("#get-started-footer").hide();
				} else {
					$("#get-started-footer").show();
				}
			});
		}
	}

	$("#static-header").toggleClass(
		"main-header",
		!$(".main-header").length
	)

	$("#static-header-2").toggleClass("main-header", !$(".main-header").length);

	$("<div class='top-overlay'></div>").prependTo(".site-wrapper");
	

	// HOME PAGE
	$(".service-main-img .single-slider").each(function () {
		$(this)
			.clone()
			.removeClass("single-slider")
			.addClass("single-reverse")
			.appendTo(".service-slider-wrap");
	});

	var serviceText = [];
	$(".service-slider-title").each(function () {
		serviceText.push($(this));
	});

	var elements = $();
	for (var x = 0; x < serviceText.length; x++) {
		elements = elements.add("<a href='#'>" + serviceText[x][0].innerHTML + "</a>");
	}
	$(".service-nxt-txt").append(elements);

	owlResp();

	$(".single-reverse").owlCarousel({
		dots: false,
		nav: false,
		loop: true,
		mouseDrag: false,
		touchDrag: false,
		items: 1,
		lazyLoad: true,
		margin: 0,
		startPosition: 1
	});

	var syncSlider = $(".single-slider");
	var syncSliderItems =
		syncSlider.find(".single-slider--item").length > 1 ? true : false;
	syncSlider.owlCarousel({
		items: 1,
		lazyLoad: true,
		loop: syncSliderItems,
		margin: 0,
		nav: false,
		dots: syncSliderItems,
		mouseDrag: false,
		touchDrag: false,
		onTranslated: function () {}
	});

	$(".service-nxt-txt").owlCarousel({
		dots: false,
		nav: false,
		loop: true,
		mouseDrag: false,
		touchDrag: false,
		items: 1,
		lazyLoad: true,
		margin: 0,
		startPosition: 1
	});

	var storiesSlider = $(".stories-slider");
	var storiesSliderItems =
		storiesSlider.find(".stories-slider .item").length > 1 ? true : false;
	storiesSlider.owlCarousel({
		loop: true,
		nav: true,
		autoWidth: true,
		dots: false,
		margin: 20,
		lazyLoad: true,

		responsive: {
			0: {
				items: 2,
				nav: false,
				margin: 20
			},

			480: {
				items: 5,
				nav: false,
				margin: 20
			},

			768: {
				items: 6,
				nav: true,
				margin: 20
			},
			1600: {
				items: 6,
				nav: true,
				margin: 20
			}
		}
	});

	$(".custom-tabs li a").on("click", function (e) {
		var currentAttrValue = jQuery(this).attr("href");
		// Show/Hide Tabs
		$(".tab" + currentAttrValue)
			.fadeIn(400)
			.siblings()
			.hide();

		// Change/remove current tab to active
		$(this)
			.parent("li")
			.addClass("active")
			.siblings()
			.removeClass("active");
		e.preventDefault();
	});
	$(".upcoming-sec-wrap").each(function () {
		$(this)
			.find(".custom-tabs li a")
			.eq(0)
			.trigger("click");
	});

	$(".service-next").click(function (e) {
		e.preventDefault();
		syncSlider.trigger("next.owl.carousel");
		$(".single-reverse").trigger("next.owl.carousel");
		$(".service-nxt-txt").trigger("next.owl.carousel");
	});
	$(".service-prev").click(function (e) {
		e.preventDefault();
		syncSlider.trigger("prev.owl.carousel");
		$(".single-reverse").trigger("prev.owl.carousel");
		$(".service-nxt-txt").trigger("prev.owl.carousel");
	});
	$(".service-nxt-txt a").click(function (e) {
		e.preventDefault();
		syncSlider.trigger("next.owl.carousel");
		$(".single-reverse").trigger("next.owl.carousel");
		$(".service-nxt-txt").trigger("next.owl.carousel");
	})

	if ($(".menu-icon").is(":visible")) {
		if (menuflag_) {
			menuMobClone();
			menuflag_ = false;
		}
	} else {
		if (!menuflag_) {
			$(".mobile-li").remove();
			menuflag_ = true;
		}
	}
});

$(window).bind("load", function () {
	navbarHeight = $('#static-header').outerHeight();
	if ($(".blankDiv").length) {
		$(".blankDiv").height($("#static-header").outerHeight());
	}
	$(".banner-slider").trigger('refresh.owl.carousel', [100]);
});

function menuMobClone() {
	var blankDiv = $("<ul>", {
		class: "mob-nav"
	});
	blankDiv.insertBefore($(".primary-nav"));
	$(".mobile-link").each(function () {
		$(this).clone().addClass("mobile-li").appendTo(".mob-nav");
	});
	$(".select-region-wrap").clone().addClass("mobile-li select-mobile").prependTo(".mob-nav");
}

$(window).resize(function () {
	if ($(".blankDiv").length) {
		$(".blankDiv").height($("#static-header").outerHeight());
	}
	setTimeout(function () {
		if ($(".blankDiv").length) {
			$(".blankDiv").height($("#static-header").outerHeight());
		}
	}, 301);
	owlResp();
	if (window.innerWidth < 851) {
		if (menuflag_) {
			menuMobClone();
			menuflag_ = false;
		}
	} else {
		if (!menuflag_) {
			$(".mob-nav, .mobile-li").remove();
			menuflag_ = true;
			$(".menu-icon.active").trigger("click");
		}
	}
});

$(window).scroll(function () {
	if ($(document).scrollTop() == 0) {
		$('body').removeClass('nav-down');

		if ($(".blankDiv").length) {
			$(".blankDiv").height($("#static-header").outerHeight());
		}
	}
});

function owlResp() {
	if (window.innerWidth <= 767) {
		if (owlRespFlag_) {
			owlRespFlag_ = false;
			$(".banner-slider").trigger("destroy.owl.carousel");
			$(".banner-slider").removeClass("owl-carousel");
		}
	} else {
		owlRespFlag_ = true;
		var bannerSlider = $(".banner-slider");
		bannerSlider.addClass("owl-carousel");
		var bannerSliderItems =
			bannerSlider.find(".banner-slider--item").length > 1 ? true : false;
		bannerSlider.owlCarousel({
			items: 1,
			lazyLoad: true,
			loop: bannerSliderItems,
			margin: 0,
			nav: false,
			animateOut: 'fadeOut',
			animateIn: 'fadeIn',
			mouseDrag: false,
			touchDrag: false,
			dots: bannerSliderItems,
			autoplay: true,
			autoplayTimeout: homeHeroSlideDuration * 1000,
			autoplayHoverPause: false
		});

		const carouselImages = {'.hpimage1': 1, '.hpimage2': 2, '.hpimage3':3};
		Object.keys(carouselImages).map(function(div) {
			$(div).on('click', function URL(){
				window.location = (carouselImages[div] === 1) ? "/fleet/dash-cam" : (carouselImages[div] === 2) ? "/fleet/reefer-monitoring" : "/fleet/gps-fleet-tracking";
			})
			$(div).hover(function () {$(this).css("cursor","pointer")});
		});
	}
}

$(window).scroll(function () {
	didScroll = true;

	let dist = $(this).scrollTop();
	let header = $("#static-header");

	let getStarted = $("#get-started-header");

	if (header.length && getStarted.length) {
		let top = header.offset().top + header.height() + 40;
		getStarted.toggleClass(
			"active",
			dist > top
		);
	}
});

setInterval(function () {
	if (didScroll) {
		hasScrolled();
		didScroll = false;
	}
}, 250);

function hasScrolled() {
	var st = $(this).scrollTop();

	// Make scroll more than delta
	if (Math.abs(lastScrollTop - st) <= delta)
		return;

	// If scrolled down and past the navbar, add class .nav-up.
	if (st > lastScrollTop && st > navbarHeight) {
		// Scroll Down
		$('body').removeClass('nav-down').addClass('nav-up');
	} else {
		// Scroll Up
		if (st + $(window).height() < $(document).height()) {
			$('body').removeClass('nav-up').addClass('nav-down');
		}
		if ($(this).scrollTop() == 0) {
			$('body').removeClass('nav-down');
			if ($(".blankDiv").length) {
				$(".blankDiv").height($("#static-header").outerHeight());
			}
		}
	}

	lastScrollTop = st;
}

function PerformCalc1() {
	if (up1 == true && value1 <= ceiling1) {
		value1 += increment

		if (value1 == ceiling1) {
			up1 = false;
		}
	} else {
		up1 = false
		value1 -= increment;

		if (value1 == 63) {
			up1 = true;
		}
	}
	$(".anim-car-1 .proximity-text span").html(value1);
}

function PerformCalc2() {
	if (up2 == true && value2 <= ceiling2) {
		value2 += increment;
		if (value2 == ceiling2) {
			up2 = false;
		}
	} else {
		up2 = false
		value2 -= increment;
		if (value2 == 37) {
			up2 = true;
		}
	}
	$(".anim-car-2 .proximity-text span").html(value2);
	setTimeout(PerformCalc2, 163);
}
PerformCalc2();

function PerformCalc() {
	if (up == true && value <= ceiling) {
		value += increment
		if (value == ceiling) {
			up = false;
			value3 += increment;
		}
		if (value3 == 10) {
			up = false;
			value3 = 6;
		}
	} else {
		value = 0
		up = true
	}
	$(".timer .clock").text('June 7th, ' + " " + value3 + " : " + value + " " + 'pm')
}

function PerformCalc3() {
	if (up3 == true && value4 <= ceiling3) {
		value4 += increment

		if (value4 == ceiling3) {
			up3 = false;
		}
	} else {
		up3 = false
		value4 -= increment;

		if (value4 == 1) {
			up3 = true;
		}
	}
	$(".anim-temp span").text(value4)
}
